import { render, staticRenderFns } from "./EventMain.vue?vue&type=template&id=3965875a&scoped=true&"
import script from "./EventMain.vue?vue&type=script&lang=js&"
export * from "./EventMain.vue?vue&type=script&lang=js&"
import style0 from "./EventMain.vue?vue&type=style&index=0&id=3965875a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3965875a",
  null
  
)

export default component.exports